// SM3. Строки таблицы «Выгрузки» из ответа GET /api/journal-s3/days: ревизии суток и пропуски.
// Пропуск — сутки внутри выгрузок установки, у которых нет ни одной ревизии в бакете (сервер не выгрузил).

const isoDay = (date) => date.toISOString().slice(0, 10);

export const defaultWindow = (now) => {
  const to = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  const from = new Date(to.getTime() - 13 * 24 * 3600 * 1000);
  return { from: isoDay(from), to: isoDay(to) };
};

export const formatBytes = (value) => {
  if (value === null || value === undefined) return '—';
  if (value < 1024) return `${value} Б`;
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} КБ`;
  return `${(value / 1024 / 1024).toFixed(1)} МБ`;
};

export const buildExportRows = (data) => {
  if (!data) return [];
  const byUuid = Object.fromEntries((data.installations || []).map((item) => [item.installation_uuid, item]));
  const rows = (data.days || []).map((day) => ({
    ...day,
    key: `d${day.id}`,
    connection_name: byUuid[day.installation_uuid]?.connection_name || null,
  }));
  Object.entries(data.gaps || {}).forEach(([uuid, days]) => {
    const item = byUuid[uuid];
    days.forEach((day) => {
      rows.push({
        key: `g${uuid}${day}`,
        id: null,
        day,
        installation_uuid: uuid,
        installation_name: item?.installation_name || '—',
        connection_name: item?.connection_name || null,
        revision: null,
        rows: null,
        bytes: null,
        uploaded_at: null,
        state: 'gap',
      });
    });
  });
  // Свежие сутки сверху; внутри суток — по серверу, старшая ревизия первой.
  return rows.sort((a, b) => (
    b.day.localeCompare(a.day)
    || String(a.connection_name || a.installation_name).localeCompare(String(b.connection_name || b.installation_name))
    || (b.revision || 0) - (a.revision || 0)
  ));
};
